export const baseApiRoute = 'https://qxqadmin.info/api';
export const baseOeaAppUrl = 'https://qxqempresa.info';
export const googleMapsApiKey = 'AIzaSyCXMHgbb-SLTXiHJT1VZk_e_EN1PhZuz4k';
export const locale = 'dynamic';
export const catalanPublicWebUrl = 'https://triahigienealimentaria.info';
export const spanishPublicWebUrl =  'https://eligehigienealimentaria.info';
export const englishPublicWebUrl =  'https://choosefoodhygiene.info';




// WEBPACK FOOTER //
// ./src/assets/const.js